export const INSTA_URL = "/js/instagram.json"